<template>
    <div class="loading d-flex text-center">
        <div class="loading-animation loading-animation--hammer m-auto" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"
                class="loading-hammer" role="img" focusable="false">
                <path
                    d="m.813 26.076 14.29-17.614a.935.935 0 0 1 .08-1.064l1.167-1.44c-2.134-1.59-3.597-2.01-6.802-2.125C8.614 3.8 8.3 2.561 9.106 2.088c4.886-2.869 
                    9.464-2.78 13.238.258l3.983 3.206a.94.94 0 0 1 .14 1.321.925.925 0 0 0 .142 1.31.94.94 0 0 0 1.321-.14.937.937 0 0 1 1.316-.142l1.706 1.371c1.21.975 
                    1.4 2.742.421 3.95l-2.359 2.91a2.823 2.823 0 0 1-3.954.42l-1.706-1.37a.94.94 0 0 1-.14-1.322.927.927 0 0 0-.14-1.309.944.944 0 0 0-1.324.14.94.94 0 
                    0 1-1.038.294L6.463 30.647a3.633 3.633 0 0 1-5.113.545 3.63 3.63 0 0 1-.537-5.116m18.404-14.224-2.691-2.167-2.042 2.517 2.7 2.17zm6.063 1.128a2.8 2.8 
                    0 0 1-.143 1.23l1.098.881a.944.944 0 0 0 1.323-.14l2.359-2.909a.93.93 0 0 0-.14-1.309l-1.102-.885a2.82 2.82 0 0 1-3.242-.205 2.8 2.8 0 0 
                    1-.89-3.12l-3.374-2.716c-2.386-1.92-5.103-2.41-8.106-1.469 1.881.418 3.328 1.226 5.205 2.738a.94.94 0 0 1 .141 1.32l-1.177 1.452 3.774 3.037c1.767-1.082 
                    4.057.048 4.274 2.095M2.53 29.734c.755.61 1.863.495 2.475-.264l11.003-13.639-2.704-2.173-11.034 13.6a1.76 1.76 0 0 0 .26 2.476"
                    fill="currentColor">
                </path>
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        template: {
            default: "#vue-loading-animation",
            type: String
        }
    }
}
</script>
